import components from "./components/index.js";
import pages from "./pages/index.js";
import initRecaptcha from "./recaptcha.js";

window.addEventListener("DOMContentLoaded", () => {
    components();
    pages();
    // 問い合わせ系フォームの hidden(g-recaptcha-response) を埋める。
    // これが配信に含まれていないと空のまま送信され、サーバ側の required で必ず弾かれる。
    // recaptcha.js 自身が「site_key 未設定」「対象フォーム無し」で即 return するので、
    // 他ページや未設定環境では何もしない
    initRecaptcha();
});
